import React, { useState } from "react";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reusable/Spinner";
import loadable from "@loadable/component";
import Skeleton from "../../components/Reusable/Skeleton";

const DeliverySettingComponent = loadable(
  () => import("../../components/DeliverySetting")
);

const Delivery = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [defaultValue, setDefaultValue] = useState<any>([]);

  const handleEditStatusChange = (value: any) => {
    setDefaultValue(value);
    console.log(value);
  };

  const { data: statusList } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {
      is_active: true,
    },
  });

  const { data: gridData, isLoading } = useGetHook({
    queryKey: [`delivery-status`],
    url: `${APIS.DELIVERY_STATUS}`,
    params: {},
  });

  const { mutateAsync, isLoading: patchLoading } = usePatchHook({
    queryKey: ["delivery-status"],
    navigateURL: "",
  });

  const handleOpenEditPopup = (item: any) => {
    setSelectedItem(item);
    setDefaultValue([...item?.status_id]);
    setOpenEditPopup(true);
  };

  const handleStatusInclude = async (event: any) => {
    event.preventDefault();
    const url = `${APIS.DELIVERY_STATUS}${selectedItem?.id}/`;
    let formData = {
      status_id: defaultValue?.map((item: any) => item.id) ?? [],
    };
    try {
      const rest = await mutateAsync({ url, formData });
      if (rest.status === 200) {
        setOpenEditPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <DeliverySettingComponent
          statusList={statusList}
          gridData={gridData}
          handleOpenEditPopup={handleOpenEditPopup}
          handleEditStatusChange={handleEditStatusChange}
          handleStatusInclude={handleStatusInclude}
          defaultValue={defaultValue}
          openEditPopup={openEditPopup}
          setOpenEditPopup={setOpenEditPopup}
          patchLoading={patchLoading}
          selectedItem={selectedItem}
        />
      )}
    </>
  );
};

export default Delivery;
